import { connect } from 'react-redux';
import ProtectedRoute from '../../../components/Common/ProtectedRoute/ProtectedRoute';
import { setUser } from '../../../actions/actions-app';

const mapStateToProps = state => {
    return {
        user: state.user,
        userIsLoading: state.userIsLoading
    }
};

export default connect(
    mapStateToProps,
    { setUser }
)(ProtectedRoute);


// WEBPACK FOOTER //
// ./src/containers/Common/ProtectedRoute/ProtectedRouteContainer.js